// src/features/template/constants/index.ts
export const ALLOWED_DOMAINS = [
  'cargoforwarders.us',
  'deaal.info',
  'hzeak.in',
  'lang-en.us',
  'lifae.us',
  'liinkediin.com',
  'nochargemail.com',
  'obviouslyfakedomain.com',
  'phishpond.com',
  'securityresponse.org',
  'traulic.org',
  'trustedentity.com',
  'userid-81d.ws',
  'vaevk.org',
  'winningfootytips.com',
  'zezol.mobi',
  'serviceadministrator.network',
  'security-unauthorised-request.com',
  'document-share.services',
  'google-notifications.org',
  'thefederalgovernment.org',
  'secure-login.net.au',
  'account-management.net.au',
  'auk.co.nz',
  'passwordresets.online',
  'cardpaysecurity.org',
  'webtoinvoice.com',
  'resetnoreply.com',
  'servernotification.events',
  'authorised-support.com',
  'support-request.co.uk',
  'userid.team'
];